import React from 'react'
import { Label, Button } from 'reactstrap'
import styled from 'styled-components'
import get from 'lodash/get'
import find from 'lodash/find'
import moment from '../../../../lib/moment.js'
import { SubmitEfficiencyForm, ShowRemark } from '../../form'
import RemarkIcon from '../../../../static/images/remark-icon.svg'
import { FONTS } from '../../../../constants'

export const Header = class extends React.Component {
  state={
    showSubmit: false,
    showRemark: false,
    submitRemark: '',
  }

  clickSubmit = () => {
    this.setState({ showSubmit: !this.state.showSubmit })
  }

  submitEfficiency = (type) => {
    switch (type) {
      case 'cancel': {
        this.clickSubmit()
        break
      }
      case 'submit': {
        const submitEfficiency = get(this.props, 'submitEfficiency')
        const efficiencyID = get(this.props, 'efficiencyResource.efficiencyResource._id')
        const payload = { remark: this.state.submitRemark }
        submitEfficiency(efficiencyID, payload)
        this.clickSubmit()
        break
      }
      default: break
    }
  }

  render() {
    const efficiencyResource = get(this.props, 'efficiencyResource')
    const lob_id = get(efficiencyResource, 'efficiencyResource.lob_id')
    const lobs = get(efficiencyResource, 'lobs', [])
    const canSubmit = get(efficiencyResource, 'canSubmit')
    const is_submited = get(efficiencyResource, 'efficiencyResource.is_submited')
    const remark = get(efficiencyResource, 'efficiencyResource.remark')
    const month = get(efficiencyResource, 'efficiencyResource.month')
    const handleChangeMonth = get(this.props, 'handleChangeMonth')
    let lob = find(lobs, {
      _id: lob_id,
    })
    lob = lob ? get(lob, 'name', '-') : '-'
    const updator = get(efficiencyResource, 'updator')
    const userNotApprovedTimesheets = is_submited ?
      get(efficiencyResource, 'efficiencyResource.efficiency_resource_snapshot.userNotApprovedTimesheets', []) :
      get(efficiencyResource, 'userNotApprovedTimesheets', [])
    return (
      <Wrapper>
        <SubmitEfficiencyForm
          open={ this.state.showSubmit }
          submitEfficiency={ this.submitEfficiency }
          month={ moment(month).format('MMMM YYYY') }
          lob={ lob }
          userNotApprovedTimesheets={ userNotApprovedTimesheets }
          handleSubmitRemark={ (e) => this.setState({ submitRemark: e.target.value }) }
        />
        <ShowRemark
          open={ this.state.showRemark }
          month={ moment(month).format('MMMM YYYY') }
          lob={ lob }
          remark={ remark }
          toggle={ () => this.setState({ showRemark: !this.state.showRemark }) }
        />
        <InfoRow>
          <GroupLabel>
            <Title>Status</Title>
            <Detail color={ is_submited ? '#5CB85C' : 'grey' }>
              <Circle color={ is_submited ? '#5CB85C' : 'grey' } />
              { is_submited ? 'Submitted' : 'Unsubmitted' }
            </Detail>
          </GroupLabel>
          <GroupLabel>
            <Title>Month</Title>
            <Detail>{ moment(month).format('MMMM') }</Detail>
          </GroupLabel>
          <GroupLabel>
            <Title>Year</Title>
            <Detail>{ moment(month).format('YYYY') }</Detail>
          </GroupLabel>
          <GroupLabel>
            <Title>LOB</Title>
            <Detail>{ lob }</Detail>
          </GroupLabel>
          <GroupLabel>
            <Title>Submitted Date</Title>
            <Detail>{ is_submited ? moment(get(efficiencyResource, 'submit_date')).format('DD/MM/YYYY') : '-' }</Detail>
          </GroupLabel>
          <GroupLabel>
            <Title>Submitted By</Title>
            <Detail>
              { JSON.stringify(updator) !== JSON.stringify({}) ? `${get(updator, 'first_name')} ${get(updator, 'last_name')} (${get(updator, 'nick_name')})` : '-' }
            </Detail>
          </GroupLabel>
          <GroupLabel>
            <Title>Unapproved Timesheet</Title>
            <Detail>
              { get(userNotApprovedTimesheets, 'length', 0) }
            </Detail>
          </GroupLabel>
          { remark &&
          <GroupLabel>
            <Icon
              src={ RemarkIcon }
              onClick={ () => this.setState({ showRemark: !this.state.showRemark }) }
            />
          </GroupLabel>
          }
        </InfoRow>
        <ButtonRow>
          <ArrowButton
            background='white'
            onClick={ () => {
              handleChangeMonth(moment(month).subtract(1, 'month').format('YYYY-MM'))
            } }
          >&#65308;</ArrowButton>
          <LabelMonth>{ moment(month).format('MMMM YYYY') }</LabelMonth>
          <ArrowButton
            background='white'
            onClick={ () => {
              handleChangeMonth(moment(month).add(1, 'month').format('YYYY-MM'))
            } }
          >&#65310;</ArrowButton>
          { canSubmit &&
          <SubmitButton
            color='success'
            onClick={ () => this.clickSubmit() }
          >Submit</SubmitButton>
          }
        </ButtonRow>
      </Wrapper>
    )
  }
}

Header.propTypes = {
}
Header.defaultProps = {
}

const Wrapper = styled.div`
  background-color: #ffffff ;
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  margin-top: 10px;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`
const InfoRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 70%;
`
const ButtonRow = styled(InfoRow)`
  width: 30%;
  justify-content: flex-end;
  margin-right: 20px;
`
const GroupLabel = styled.div`
  margin-left: 2%;
`
const Title = styled(Label)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: 10px;
  color: #A9A9A9;
  margin-right: 10px;
  margin-bottom: 0px;
`
const Detail = styled.span`
  display: flex;
  margin-right: 10px;
  color: ${props => props.color};
`
const Circle = styled.div`
  font-size: 15px;
  color: #FFFFFF;
  text-align: center;
  line-height: 15px;
  height: 10px;
  width: 10px;
  background-color: ${props => props.color};
  border-radius: 50%;
  margin: 5px;
  margin-left: 0px;
`
const ArrowButton = styled(Button)`
  height: 30px;
  width: 40px;
  margin-left: 5px;
  margin-right: 5px;
  text-align: center;
  background: ${(props) => { return props.background }};
  color: black;
  font-size: 12px;
  border: 1px solid #E6E6E6;
`
const LabelMonth = styled.label`
  width: 100px;
  font-size: 12px;
  margin-top: 2%;
  text-align: center;
`
const SubmitButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  height: 30px;
  width: 70px;
  margin-left: 5px;
  margin-right: 5px;
  text-align: center;
`
const Icon = styled.img`
  height: 25px;
  width: 25px;
  margin-right: 5px;
  margin-bottom: auto ;
  margin-top: auto;
  cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab-content/lob-submit/header.js